import {
  DEFAULT_ECONOMIC_IMPACT_GEOGRAPHY,
  DEFAULT_ECONOMIC_IMPACT_INDUSTRY_CLASSIFICATION,
  type PreferenceScope,
  UserPreferenceKey,
  type UserPreferences,
} from '../types';
import { MSA_GEOGRAPHY_TAXONOMY_ID } from './geography-preference';

export const getDefaultPreferences = (
  _scope: PreferenceScope
): UserPreferences => {
  return {
    [UserPreferenceKey.ContingentWorkers]: false,
    // Single GLOBAL taxonomy choice. Adaptive is the default; non-company
    // surfaces derive Generic at the preference→filter boundary
    // (deriveEffectiveTaxonomiesForScope), never in the stored value.
    [UserPreferenceKey.Taxonomies]: {
      role: 'adaptive',
      skill: 'adaptive',
      activity: 'adaptive',
    },
    [UserPreferenceKey.DataAdjustments]: false,
    [UserPreferenceKey.Currency]: { code: 'USD', rate: 1 },
    [UserPreferenceKey.DefaultFilters]: [],
    [UserPreferenceKey.Geography]: { taxonomyId: MSA_GEOGRAPHY_TAXONOMY_ID },
    [UserPreferenceKey.PageOrder]: [],
    [UserPreferenceKey.ColorMode]: 'system',
    [UserPreferenceKey.EconomicImpactIndustries]:
      DEFAULT_ECONOMIC_IMPACT_INDUSTRY_CLASSIFICATION,
    [UserPreferenceKey.EconomicImpactGeography]:
      DEFAULT_ECONOMIC_IMPACT_GEOGRAPHY,
  };
};
